import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Form from './form';
import { generalClasses as styles } from './styles';

const Edit = ({ classes, history, location: { entity } }) => {
  return (
    <Card className={classes.card}>
      <CardHeader title="Modificar Visitado" />
      <CardContent className={classes.cardContent}>
        <Card className={classes.formCard}>
          <CardContent className={classes.cardContent}>
            <Form classes={classes} entity={entity} history={history} />
          </CardContent>
        </Card>
      </CardContent>
    </Card>
  );
};

export default withStyles(styles)(Edit);
